<script>
    import { fly } from "svelte/transition";
    import { portal } from "svelte-portal";
    import { onMount, createEventDispatcher } from "svelte";
    import PickerView from "./PickerView.svelte";
    import { getColumnsData } from "../../utils";
    export let title = "标题";
    export let confirmText = "确定";
    export let cancelText = "取消";
    export let unit = "";
    export let show = false;
    const dispatch = createEventDispatcher();
    let columns = [];
    let value = []; //选中的内容列表
    let clsName = "cascade-picker";
    onMount(() => {
        fetch("/api/ss.json")
            .then((response) => response.json())
            .then((res) => {
                const options = [
                    {
                        name: "浙江浙江浙江",
                        value: "浙江",
                        children: [
                            {
                                name: "杭州",
                                value: "杭州杭州杭州杭州",
                            },
                            {
                                name: "宁波",
                                value: "宁波",
                                children: [
                                    {
                                        name: "街道",
                                        value: "街道",
                                        children: [
                                            {
                                                name: "小区1",
                                                value: "小区1",
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        name: "江苏",
                        value: "江苏",
                        children: [
                            {
                                name: "南京",
                                value: "南京",
                            },
                            {
                                name: "苏州",
                                value: "苏州",
                                children: [
                                    {
                                        name: "街道",
                                        value: "街道",
                                        children: [
                                            {
                                                name: "小区2",
                                                value: "小区2",
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ];
                if (res.data && res.data.length > 0) {
                    // items = options;
                    columns = getColumnsData(options);
                }
            });
    });
    //点击取消
    function handleCancel() {
        dispatch("cancel");
        setDefaultVal();
    }
    //点击确定
    function handleConfirm() {
        dispatch("confirm", getResult());
        // dispatch("select", getResult());
        // setDefaultVal();
    }

    function getResult() {
        let hook = [];
        columns.map((el) => {
            el.defaultValue !== "" && hook.push(el.defaultValue);
        });
        return hook;
    }
    //
    function setDefaultVal() {
        const val = JSON.parse(JSON.stringify(value));
        if (value.length > 0) {
            pVal = val[0].name;
            cVal = val[1].name;
        }
    }
    //监控
    function listenChange(e) {
        const { val, name, index } = e.detail || {};
        columns[index].defaultValue = val.value;
        if (val.children) {
            chooseInit(val, index);
        } else {
            resetFn(index);
        }
    }

    function chooseInit(res, index) {
        let c = res;
        while (c.children) {
            index++;
            columns[index].items = c.children;
            columns[index].defaultValue = c.children[0].value;
            c = c.children[0];
        }
        resetFn(index);
    }

    function resetFn(index) {
        if (index + 1 >= columns.length) return;
        columns = columns.map((el, i) => {
            if (i > index) {
                el.items = [];
                el.defaultValue = "";
            }
            return el;
        });
    }

    let el;
    function start() {
        setTimeout(() => {
            el.classList.add("show");
        });
    }
    $: console.log(columns);
</script>

{#if show}
    <div
        class={`${clsName}-box`}
        transition:fly={{ y: 200, duration: 300 }}
        on:introstart={start}
        use:portal={"body"}
        bind:this={el}
    >
        <div class={clsName}>
            <div class={`${clsName}-actions`}>
                <div
                    role="button"
                    class={`${clsName}-actions-btn`}
                    on:click={handleCancel}
                >
                    {cancelText}
                </div>
                {#if title}
                    <h4>{title}</h4>
                {/if}
                <div
                    role="button"
                    color="primary"
                    class={`${clsName}-actions-btn`}
                    on:click={handleConfirm}
                >
                    {confirmText}
                </div>
            </div>

            <div class={`${clsName}-content`}>
                {#each columns as column, i (column.id)}
                    <PickerView
                        {unit}
                        class={`${clsName}-content-cell`}
                        on:change={listenChange}
                        value={column.defaultValue}
                        items={column.items || []}
                        index={i}
                    />
                {/each}
            </div>
        </div>
    </div>
{/if}

<style lang="less">
    @import "./cascadePicker.less";
</style>
